<template>
  <div>
    <page-header>
      <slot name="header" />
    </page-header>
    <div class="container-fluid">
      <slot />
    </div>
    <page-footer>
      <slot name="footer" />
    </page-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageHeader from "./PageHeader.vue";
import PageFooter from "./PageFooter.vue";
export default {
  name: "PageLayout",
  components: {
    PageHeader,
    PageFooter,
  },
  computed: {
    ...mapGetters("oidcStore", [
      "oidcIsAuthenticated",
      "oidcAuthenticationIsChecked",
    ]),
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 0px 50px 0px 50px;
}
</style>